import React, { Component, createRef, useState, useEffect } from "react";
import { Row, Col, Card, Button, Space, Typography, Table, Input, Modal, Tag, Tooltip, Checkbox } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash, faSearch } from "@fortawesome/free-solid-svg-icons";
import _ from "lodash";

const NEW_JOB_STATUS_BASE_STATE = { name: "" };

function TaskStatuses(props) {
  const [TaskStatuses, setTaskStatuses] = useState([]);
  const [filteredTaskStatuses, setFilteredTaskStatuses] = useState([]);
  const [searchTerm, setSearchTerm] = useState(null);

  const [selectedTaskStatus, setSelectedTaskStatus] = useState(null);
  const [editModalOpen, setEditModalOpen] = useState(false);

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const [addModalOpen, setAddModalOpen] = useState(false);
  const [newTaskStatus, setNewTaskStatus] = useState(NEW_JOB_STATUS_BASE_STATE);

  const table_columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text) => <Typography.Title level={5}>{text}</Typography.Title>,
      sorter: (a, b) => (a.name > b.name ? 1 : -1),
      defaultSortOrder: "ascend",
    },
    {
      title: "",
      dataIndex: "start",
      key: "start",
      render: (text, object) => (
        <>
          {object.start ? (
            <Tooltip title="This is the default status that new tasks will be created with">
              <Tag>Starting Status</Tag>
            </Tooltip>
          ) : null}{" "}
          {object.end ? (
            <Tooltip title="This is the status that marks a task as being finished">
              <Tag>Complete Status</Tag>
            </Tooltip>
          ) : null}
        </>
      ),
    },
    {
      title: "Actions",
      align: "right",
      dataIndex: "id",
      key: "id",
      render: (text, row) => (
        <Space>
          <Button
            size="small"
            type="primary"
            onClick={() => {
              setEditModalOpen(true);
              setSelectedTaskStatus(TaskStatuses.find((f) => f.id === text));
            }}
          >
            <FontAwesomeIcon icon={faEdit} className="mr-1" />
            Edit
          </Button>
          <Button
            size="small"
            danger
            onClick={() => {
              setDeleteModalOpen(true);
              setSelectedTaskStatus(TaskStatuses.find((f) => f.id === text));
            }}
          >
            <FontAwesomeIcon icon={faTrash} className="mr-1" />
            Delete
          </Button>
        </Space>
      ),
    },
  ];

  const GetTaskStatuses = async () => {
    let response = await props.AxiosRequest("/api/task-statuses/get");
    setTaskStatuses(response.data.task_statuses);
    setFilteredTaskStatuses(response.data.task_statuses);
  };
  const UpdateTaskStatus = async () => {
    await props.AxiosRequest("/api/task-statuses/update", { id: selectedTaskStatus.id, name: selectedTaskStatus.name, start: selectedTaskStatus.start ? 1 : 0, end: selectedTaskStatus.end ? 1 : 0 });
    GetTaskStatuses();
    setEditModalOpen(false);
    setSelectedTaskStatus(null);
  };
  const DeleteTaskStatus = async () => {
    await props.AxiosRequest("/api/task-statuses/delete", { id: selectedTaskStatus.id });
    GetTaskStatuses();
    setDeleteModalOpen(false);
    setSelectedTaskStatus(null);
  };
  const AddTaskStatus = async () => {
    if (newTaskStatus.name.length === 0) return props.MakeNotification("info", "Please Enter All Required Fields.");
    await props.AxiosRequest("/api/task-statuses/insert", { ...newTaskStatus, start: newTaskStatus.start ? 1 : 0, end: newTaskStatus.end ? 1 : 0 });
    GetTaskStatuses();
    setAddModalOpen(false);
    setNewTaskStatus(NEW_JOB_STATUS_BASE_STATE);
  };

  useEffect(() => {
    GetTaskStatuses();
  }, []);

  useEffect(() => {
    if (searchTerm?.length === 0) return setFilteredTaskStatuses(TaskStatuses);
    let filtered_list = TaskStatuses.filter((f) => (_.toLower(f.name).indexOf(_.toLower(searchTerm)) > -1 ? true : false));
    setFilteredTaskStatuses(filtered_list);
  }, [searchTerm]);

  return (
    <main className="content">
      <div className="container-fluid">
        <div className="header">
          <h1 className="header-title">Task Statuses</h1>
        </div>
        <Row>
          <Card
            title={<>Task Statuses</>}
            style={{
              width: "100%",
            }}
            extra={
              <>
                <Button
                  type="primary"
                  onClick={() => {
                    setNewTaskStatus(NEW_JOB_STATUS_BASE_STATE);
                    setAddModalOpen(true);
                  }}
                >
                  <FontAwesomeIcon icon="plus" className="me-2" />
                  Add A New Task Status
                </Button>
              </>
            }
          >
            <Row>
              <Col span={18}></Col>
              <Col span={6}>
                <Input
                  className="mb-2"
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                  }}
                  placeholder="Search..."
                  allowClear
                />
              </Col>
            </Row>
            <Table className="table table-striped hover" columns={table_columns} dataSource={filteredTaskStatuses} />
          </Card>
        </Row>
        <Modal
          title={"Edit Task Status"}
          centered
          open={editModalOpen}
          onCancel={() => {
            setEditModalOpen(false);
            setSelectedTaskStatus(null);
          }}
          footer={
            <>
              <Button
                onClick={() => {
                  setEditModalOpen(false);
                  setSelectedTaskStatus(null);
                }}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                onClick={() => {
                  UpdateTaskStatus();
                }}
              >
                Save Changes
              </Button>
            </>
          }
        >
          {selectedTaskStatus ? (
            <>
              <Row>
                <Col span={24}>
                  <label className="col-form-label-sm">Task Status Name *</label>
                  <Input
                    value={selectedTaskStatus.name}
                    onChange={(e) => {
                      setSelectedTaskStatus({ ...selectedTaskStatus, name: e.target.value });
                    }}
                  />
                </Col>
                <Col span={24}>
                  <label className="col-form-label-sm">Status Settings</label>
                </Col>
                <Col span={12}>
                  <Checkbox
                    checked={selectedTaskStatus.start}
                    onChange={(e) => {
                      setSelectedTaskStatus({ ...selectedTaskStatus, start: e.target.checked });
                    }}
                  >
                    Starting Status
                  </Checkbox>
                </Col>
                <Col span={12}>
                  <Checkbox
                    checked={selectedTaskStatus.end}
                    onChange={(e) => {
                      setSelectedTaskStatus({ ...selectedTaskStatus, end: e.target.checked });
                    }}
                  >
                    Complete Status
                  </Checkbox>
                </Col>
              </Row>
            </>
          ) : null}
        </Modal>

        <Modal
          title={"Are you sure?"}
          centered
          open={deleteModalOpen}
          onCancel={() => {
            setDeleteModalOpen(false);
            setSelectedTaskStatus(null);
          }}
          footer={
            <>
              <Button
                onClick={() => {
                  setDeleteModalOpen(false);
                  setSelectedTaskStatus(null);
                }}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                danger
                onClick={() => {
                  DeleteTaskStatus();
                }}
              >
                Delete
              </Button>
            </>
          }
        >
          {selectedTaskStatus ? <>Are you sure you want to delete the task status {selectedTaskStatus?.name}?</> : null}
        </Modal>

        <Modal
          title={"Add A New Task Status"}
          centered
          open={addModalOpen}
          onCancel={() => {
            setAddModalOpen(false);
            setSelectedTaskStatus(null);
          }}
          footer={
            <>
              <Button
                onClick={() => {
                  setAddModalOpen(false);
                  setSelectedTaskStatus(null);
                }}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                onClick={() => {
                  AddTaskStatus();
                }}
              >
                Add
              </Button>
            </>
          }
        >
          {newTaskStatus ? (
            <>
              <Row>
                <Col span={24}>
                  <label className="col-form-label-sm">Task Status Name *</label>
                  <Input
                    value={newTaskStatus.name}
                    onChange={(e) => {
                      setNewTaskStatus({ ...newTaskStatus, name: e.target.value });
                    }}
                  />
                </Col>
                <Col span={24}>
                  <label className="col-form-label-sm">Status Settings</label>
                </Col>
                <Col span={12}>
                  <Checkbox
                    checked={newTaskStatus.start}
                    onChange={(e) => {
                      setNewTaskStatus({ ...newTaskStatus, start: e.target.checked });
                    }}
                  >
                    Starting Status
                  </Checkbox>
                </Col>
                <Col span={12}>
                  <Checkbox
                    checked={newTaskStatus.end}
                    onChange={(e) => {
                      setNewTaskStatus({ ...newTaskStatus, end: e.target.checked });
                    }}
                  >
                    Complete Status
                  </Checkbox>
                </Col>
              </Row>
            </>
          ) : null}
        </Modal>
      </div>
    </main>
  );
}

export default TaskStatuses;
